import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import Config from '../../config';

const HEIGHT_SIZE_SM = {
  short: '20px',
  tall: '24px'
};
const HEIGHT_SIZE_MD = {
  short: '20px',
  tall: '32px'
};

export const StyledTag = withTheme(styled.span`
  ${({ coreTheme, customStyle, color, size, rounded }) => css`
      color: ${coreTheme.cl_white};
      background-color: ${color};
      padding: ${customStyle.width === '100%' ? '0 0px' : '0 16px'};
      font-family: ${coreTheme.ff_sec_bold};
      font-size: 12px;
      height: ${HEIGHT_SIZE_SM[size]};
      line-height: 1.5;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;

      ${() => {
        if (rounded) {
          return `border-top-left-radius: ${customStyle.borderTopLeftRadius};
            border-top-right-radius: ${customStyle.borderTopRightRadius};
            border-bottom-left-radius: ${customStyle.borderBottomLeftRadius};
            border-bottom-right-radius: ${customStyle.borderBottomRightRadius};`;
        }
        return 'border-radius: 0;';
      }}

      width: ${customStyle.width};
    `}

  ${Config.media.md`
    font-size: 14px;
    height: ${props => HEIGHT_SIZE_MD[props.size]};
  `};
`);
